import OrganizationServer from "@/api/organization";

export default {
    namespaced: true,
    state: {
        loading: false,
        menus: [],   //菜单级联选择器
        menuPlaceholder: null,  //菜单级联数据加载提示
        menuDisable: false,
        form: {
            model: {
                id: null,
                parentId: null,
                parentName: null,
                name: null,
                code: null,
                description: null,
                sort: 0,
                url: null,
                icon: null,
                urlParams: null,
                isRouter: false,
                status: false,
                menuVersion: 3,
                fullPath: null, //菜单级联选择数据的全路径
                createUserName: null,
                createTime: null,
                lastUpdateUserName: null,
                lastUpdateTime: null,
            }
        },
    },
    getters: {
        ['PermissionMenuFormGetParentId'](state) {
            return state.form.model.parentId;
        },
        ['PermissionMenuFormGetStatus'](state) {
            return state.form.model.status;
        },
        ['PermissionMenuFormGetFormModel'](state) {
            return state.form.model;
        },
        ['PermissionMenuFormGetFullPath'](state) {
            return state.form.model.fullPath;
        }
    },
    mutations: {
        ['PermissionMenuFormSetFormModelToNull'](state) {
            state.form.model = {
                id: null,
                parentId: null,
                parentName: null,
                name: null,
                description: null,
                url: null,
                urlParams: null,
                icon: null,
                sort: false,
                status: false,
                menuVersion: 3,
                fullPath: null, //菜单级联选择数据的全路径
            }
        },
        ['PermissionMenuFormSetFormModel'](state, formModel) {
            state.form.model = formModel;
        },
        ['PermissionMenuFormSetLoading'](state, loading) {
            state.loading = loading;
        },
        ['PermissionMenuFormSetParentId'](state, parentId) {
            state.form.model.parentId = parentId;
        },
        ['PermissionMenuFormSetStatus'](state, status) {
            state.form.model.status = status;
        },
        ['PermissionMenuFormSetMenuDisable'](state, menuDisable) {
            state.menuDisable = menuDisable;
        },
        ['PermissionMenuFormSetMenuPlaceHolder'](state, menuPlaceHolder) {
            state.menuPlaceholder = menuPlaceHolder;
        },
        ['PermissionMenuFormSetMenus'](state, menus) {
            state.menus = menus;
        },
        ['PermissionMenuFormSetFullPath'](state, fullPath) {
            state.form.model.fullPath = fullPath;
        }
    },
    actions: {
        async queryFormModel({commit}, id) {
            commit('PermissionMenuFormSetLoading', true);
            try {
                let res = await OrganizationServer.permissionMenu.findById(id);
                if (res.data.code !== '200') {
                    commit('PermissionMenuFormSetLoading', false);
                    this.$message.error(res.data.message);
                }
                let model = res.data.data;
                if (model.fullPath.length === 0) {
                    commit('PermissionMenuFormSetMenuPlaceHolder', '无');
                }
                commit('PermissionMenuFormSetFormModel', model);
                commit('PermissionMenuFormSetLoading', false);
            } catch (e) {
                commit('PermissionMenuFormSetLoading', false);
            }
        },
        async addForm({commit}, formModel) {
            //设置类型
            commit('PermissionMenuFormSetLoading', true);
            try {
                let result = await OrganizationServer.permissionMenu.add(formModel);
                commit('PermissionMenuFormSetLoading', false);
                if (result.data.code === '200') {
                    commit('PermissionMenuFormSetFormModel', result.data.data);
                    return true;
                } else {
                    this.$message.error(result.data.message);
                    return false;
                }
            } catch (e) {
                commit('PermissionMenuFormSetLoading', false);
                throw e;
            }
        },
        async updateForm({commit}, formModel) {
            commit('PermissionMenuFormSetLoading', true);
            try {
                let result = await OrganizationServer.permissionMenu.update(formModel.id, formModel);
                commit('PermissionMenuFormSetLoading', false);
                if (result.data.code === '200') {
                    commit('PermissionMenuFormSetFormModel', result.data.data);
                    return true;
                } else {
                    this.$message.error(result.data.message);
                    return false;
                }
            } catch (e) {
                commit('PermissionMenuFormSetLoading', false);
                throw e;
            }
        },
        /**
         * 获取菜单级联选择内容
         * @returns {Promise<boolean>}
         */
        async menusSelect({commit},version) {
            // commit('PermissionMenuFormSetMenuDisable', true);
            commit('PermissionMenuFormSetMenuPlaceHolder', '加载中');
            let result = await OrganizationServer.permissionMenu.menusSelect(version);
            if (result.data.code === '200') {
                commit('PermissionMenuFormSetMenus', result.data.data);
                // commit('PermissionMenuFormSetMenuDisable', false);
                commit('PermissionMenuFormSetMenuPlaceHolder', '请选择');
                return true;
            } else {
                commit('PermissionMenuFormSetMenuPlaceHolder', '加载失败,请重试');
                return false;
            }
        },
    }
}
